import { useFlag } from '@/feature/feature-flags'

export type DownsamplingThresholdMap = Record<number, number>

// If LD flag is not set, this is the default behavior
const DEFAULT_THRESHOLDS: DownsamplingThresholdMap = {
  2000: 1000,
  5000: 2500,
  10000: 5000,
  10001: 7500,
}

export const useLineStringDownsamplingConfig = (): DownsamplingThresholdMap =>
  useFlag<DownsamplingThresholdMap>('linestringDownsamplingThresholds', DEFAULT_THRESHOLDS)
